<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 24 30"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g transform="translate(-862.000000, -403.000000)" :fill="color" fill-rule="nonzero">
				<g transform="translate(109.000000, 60.000000)">
					<g transform="translate(46.000000, 293.000000)">
						<g transform="translate(229.000000, 46.000000)">
							<g transform="translate(478.000000, 4.000000)">
								<path
									d="M19.5,3 L17.7230531,3 C17.1020508,1.25747685 15.4553833,0.0021972 13.5,0 L10.5,0 C8.54461665,0.0021972 6.8979492,1.25747685 6.27694695,3 L4.5,3 C2.01580815,3.00274665 0.00274665,5.01580815 0,7.5 L0,25.5 C0.00274665,27.9841919 2.01580815,29.9972534 4.5,30 L19.5,30 C21.9841919,29.9972534 23.9972534,27.9841919 24,25.5 L24,7.5 C23.9972534,5.01580815 21.9841919,3.00274665 19.5,3 Z M7.5,4.5 C7.5021057,2.84399415 8.84399415,1.5021057 10.5,1.5 L13.5,1.5 C15.1560058,1.5021057 16.4978943,2.84399415 16.5,4.5 L16.5,6 L7.5,6 L7.5,4.5 Z M22.5,25.5 C22.4978943,27.1560058 21.1560058,28.4978943 19.5,28.5 L4.5,28.5 C2.84399415,28.4978943 1.5021057,27.1560058 1.5,25.5 L1.5,7.5 C1.5021057,5.84399415 2.84399415,4.5021057 4.5,4.5 L6,4.5 L6,6.75 C6.00027465,7.16482545 6.3359985,7.50027465 6.75,7.5 L17.25,7.5 C17.6648254,7.49972535 18.0002747,7.1640015 18,6.75 L18,4.5 L19.5,4.5 C21.1560058,4.5021057 22.4978943,5.84399415 22.5,7.5 L22.5,25.5 Z M15.75,16.5 L8.25,16.5 C7.8358155,16.5 7.5,16.8358155 7.5,17.25 C7.5,17.6641845 7.8358155,18 8.25,18 L15.75,18 C16.1641845,18 16.5,17.6641845 16.5,17.25 C16.5,16.8358155 16.1641845,16.5 15.75,16.5 Z M5.875,16.5 L4.625,16.5 C4.55596925,16.5 4.5,16.8358155 4.5,17.25 C4.5,17.6641845 4.55596925,18 4.625,18 L5.875,18 C5.94403075,18 6,17.6641845 6,17.25 C6,16.8358155 5.94403075,16.5 5.875,16.5 Z M14.375,21 L8.125,21 C7.77984625,21 7.5,21.3358155 7.5,21.75 C7.5,22.1641845 7.77984625,22.5 8.125,22.5 L14.375,22.5 C14.7201537,22.5 15,22.1641845 15,21.75 C15,21.3358155 14.7201537,21 14.375,21 Z M5.875,21 L4.625,21 C4.55596925,21 4.5,21.3358155 4.5,21.75 C4.5,22.1641845 4.55596925,22.5 4.625,22.5 L5.875,22.5 C5.94403075,22.5 6,22.1641845 6,21.75 C6,21.3358155 5.94403075,21 5.875,21 Z M18.75,12 L8.25,12 C7.8358155,12 7.5,12.3358155 7.5,12.75 C7.5,13.1641845 7.8358155,13.5 8.25,13.5 L18.75,13.5 C19.1641845,13.5 19.5,13.1641845 19.5,12.75 C19.5,12.3358155 19.1641845,12 18.75,12 Z M5.90625,12 L4.59375,12 C4.54197694,12 4.5,12.3358155 4.5,12.75 C4.5,13.1641845 4.54197694,13.5 4.59375,13.5 L5.90625,13.5 C5.95802306,13.5 6,13.1641845 6,12.75 C6,12.3358155 5.95802306,12 5.90625,12 Z"
								></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	/**
	 * name
	 */
	name: 'iconProtocols',

	/**
	 * props
	 */
	props: {
		color: {},
		width: {
			default: 24
		},
		height: {
			default: 30
		}
	}
};
</script>
